import PropTypes from "prop-types";
import pdpBlades from "@/pages/products/detailBlades";

const PlaceholderBlade = ({target, siblings}) => {

    const availablePlaceholders = {
        ...pdpBlades
        // set for more if needed in future
    }

    const PlaceholderComponent = availablePlaceholders[target.value]?.component;
    const props = availablePlaceholders[target.value]?.props;

    return availablePlaceholders[target.value] ? <PlaceholderComponent {...props} siblings={siblings}/> : <></>
};

PlaceholderBlade.propTypes = {
    target: PropTypes.object,
    siblings: PropTypes.array
};

export default PlaceholderBlade;
